import React from 'react'
import { Pane } from '../../layers'

const MenuDivider = () => {
  return <Pane borderBottom />
}

export default MenuDivider
